




import { Vue, Component } from "vue-property-decorator";
import { MsgTransports } from "@/store/types";
import DetailIncomingInfo from "@/pages/Pages/Statistics/DetailIncomingInfo.vue";

@Component({
  components: { DetailIncomingInfo },
})
export default class ViberDetailIncomingInfo extends Vue {
  private transport: MsgTransports = MsgTransports.WHATSAPP;
}
